export default "/images/vendor/flag-icons/flags/1x1/ke.svg?8bd67ea6470e92824210ef2fb422dbe0";